/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FlexRow, FlexCol } from 'sarsaparilla';
import { SearchPagination, SearchPaginationText } from 'ui-search';

import TripSearchResultCard from './TripSearchResultCard';
import * as tripPlannerActions from '../actions/tripPlanner';
import { metersToMiles, isTripEditable } from '../utils/tripUtils';
import * as types from '../constants';

class TripSearchResultList extends React.Component {
    static propTypes = {
        destination: PropTypes.object,
        destinationIndex: PropTypes.number,
        tripPlanner: PropTypes.any,
        dispatch: PropTypes.func,
        tripPlannerSearchResults: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.state = {
            uiFilters: props.tripPlanner.uiFilters,
        };

        this.onPage = this.onPage.bind(this);
    }

    componentDidMount() {
        this.refresh();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.tripPlanner.uiFilters &&
            JSON.stringify(nextProps.tripPlanner.uiFilters) !==
                JSON.stringify(this.state.uiFilters)
        ) {
            this.setState({
                uiFilters: nextProps.tripPlanner.uiFilters,
            });
            this.refresh();
        }
    }

    onPage(page) {
        this.props.dispatch(
            tripPlannerActions.updateDestinationSearchCriteria(
                this.props.destinationIndex,
                {
                    start: (page - 1) * types.DESTINATION_RESULT_PAGE_SIZE,
                }
            )
        );
        this.refresh();
    }

    refresh() {
        setTimeout(() => {
            this.props.dispatch(
                tripPlannerActions.fetchTripPlannerListSearchResults(
                    this.props.destination,
                    this.props.destinationIndex
                )
            );
        }, 300);
    }

    renderSearchResults() {
        let destinationSearchResults = null;
        if (
            this.props.tripPlannerSearchResults.listResults.length >
            this.props.destinationIndex
        ) {
            destinationSearchResults =
                this.props.tripPlannerSearchResults.listResults[
                    this.props.destinationIndex
                ];
        }
        if (destinationSearchResults && destinationSearchResults.results) {
            const editable = isTripEditable(this.props.tripPlanner.trip);

            return (
                <div>
                    {destinationSearchResults.results.map((item) => {
                        return (
                            <TripSearchResultCard
                                key={`card_${item.id}`}
                                editable={editable}
                                destination={this.props.destination}
                                destinationIndex={this.props.destinationIndex}
                                trip={this.props.tripPlanner.trip}
                                item={item}
                            />
                        );
                    })}
                </div>
            );
        }

        return null;
    }

    render() {
        let start = 0;
        let total = 0;
        let results = null;
        if (
            this.props.tripPlannerSearchResults.listResults.length >
            this.props.destinationIndex
        ) {
            results =
                this.props.tripPlannerSearchResults.listResults[
                    this.props.destinationIndex
                ];
        }
        if (results) {
            if (results.total) {
                total = parseInt(results.total, 10);
            }
            if (results.start) {
                start = parseInt(results.start, 10);
            }
        }

        return (
            <FlexRow
                className="trip-planner-search-results-list-wrapper"
                data-testid="trip-planner-search-results-list"
            >
                {this.props.destination.distance && (
                    <FlexCol xs={12} className="miles-marker">
                        <span>
                            {metersToMiles(this.props.destination.distance)} Miles
                        </span>
                    </FlexCol>
                )}
                <FlexCol className="trip-planner-search-results-list">
                    <div className="header">{this.props.destination.name}</div>
                    <div>
                        {total === 0 && (
                            <span className="h4">No matching results found</span>
                        )}

                        <SearchPaginationText
                            start={start}
                            pageSize={types.DESTINATION_RESULT_PAGE_SIZE}
                            total={total}
                        />
                    </div>

                    {this.renderSearchResults()}

                    <SearchPagination
                        start={start}
                        pageSize={types.DESTINATION_RESULT_PAGE_SIZE}
                        total={total}
                        onPage={this.onPage}
                    />
                </FlexCol>
            </FlexRow>
        );
    }
}

function select(state) {
    return {
        tripPlanner: state.tripPlanner,
        tripPlannerSearchResults: state.tripPlannerSearchResults,
    };
}

export default connect(select)(TripSearchResultList);
